import React from 'react';

import useTopKeywords from './use-top-keywords';
import { withComponentHandler } from '../../hocs/with-component-handler';
import TopKeywords from './top-keywords.desktop';

/**
 * Container component that provides data to the TopKeywords component
 * @returns {JSX.Element|null} The TopKeywords component with data or null if no data is available
 */
const TopKeywordsContainer = () => {
  const top_keywords = useTopKeywords();

  return <TopKeywords {...top_keywords} />;
};

export default withComponentHandler(TopKeywordsContainer, { componentName: 'TopKeywordsContainerDesktop' });
